import { render, staticRenderFns } from "./AmcContract.vue?vue&type=template&id=3d6a3bdc&"
import script from "./AmcContract.vue?vue&type=script&lang=js&"
export * from "./AmcContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports